export { SwitchRoot as Root } from "./root/SwitchRoot.js";
export { SwitchThumb as Thumb } from "./thumb/SwitchThumb.js";